/**
 * Divider.js
 * It slices, it dices, it divides.
 *
 * @class  Divider
 * @author  Robby Sahm
 *
 */

import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({

	propTypes: {
		bevel: React.PropTypes.bool,
		offsetLeft: React.PropTypes.number, // pixel offset left
		offsetRight: React.PropTypes.number, // pixel offset right
		marginTop: React.PropTypes.number,
		marginBottom: React.PropTypes.number

	},

	getDefaultProps() {
		return {
			bevel: false,
			offsetLeft: 0,
			offsetRight: 0,
			marginBottom: 15,
			marginTop: 15
		};
	},

	render() {

		let classes = ClassNames(this.props.className, 'lui-divider',{ 
            'lui-has-bevel' : this.props.bevel
        });

       let style = {
       		marginLeft: this.props.offsetLeft,
       		marginRight: this.props.offsetRight,
       		marginBottom: this.props.marginBottom,
       		marginTop: this.props.marginTop
        };

		return (
			<div className={classes} style={style}></div>
		);
	},
});



/** WEBPACK FOOTER **
 ** ./src/components/divider/Divider.js
 **/